module.exports = __webpack_public_path__ + "static/media/271590_screenshots_20161122212351_1.eb89d009.jpg";